import React from 'react';
import { version } from '../../../version.json';
import { useSelector } from 'react-redux';
export default function FooterSmall(props) {
  const information = useSelector((state) => state.information);
  return (
    <>
      <footer
        className={`${
          props.absolute ? 'absolute w-full bottom-0 bg-gray-800' : 'relative'
        } pb-6`}
      >
        <div className="container mx-auto px-4 print-disable ">
          <hr className="mb-6 border-b-1 border-gray-700" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4">
              <div className="text-sm text-gray-600 font-semibold py-1 text-center md:text-left">
                Copyright © {new Date().getFullYear()}{' '}
                <a
                  href={information?.system_url}
                  className="text-white hover:text-gray-400 text-sm font-semibold py-1"
                >
                  {information?.system_owner_name}
                  <br />
                  <span className="text-xs">Version {version} </span>
                </a>
              </div>
            </div>
            <div className="w-full md:w-8/12 px-4">
              <ul className="flex flex-wrap list-none md:justify-end  justify-center">
                <li>
                  <a
                    href={information?.system_sponsor_url}
                    className="text-white hover:text-gray-400 text-sm font-semibold block py-1 px-3"
                  >
                    {information?.system_sponsor}
                  </a>
                </li>
                <li>
                  <a
                    href="https://iarc.psu.ac.th/"
                    className="text-white hover:text-gray-400 text-sm font-semibold block py-1 px-3"
                  >
                    IARC PSU
                  </a>
                </li>
                {/* <li>
                  <a
                    href="https://www.facebook.com/iarc.psu/"
                    className="text-white hover:text-gray-400 text-sm font-semibold block py-1 px-3"
                  >
                    Facebook
                  </a>
                </li> */}
                {/* <li>
                  <a
                    href="https://github.com/creativetimofficial/notus-react/blob/master/LICENSE.md?ref=nr-footer-small"
                    className="text-white hover:text-gray-400 text-sm font-semibold block py-1 px-3"
                  >
                    MIT License
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
